import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function DueRemindersPage() {
  return (
    <MainLayout>
      <SEO 
        title="Lembretes de vencimento"
        description="Gerencie lembretes de vencimento"
        keywords="lembretes, vencimento"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Lembretes de vencimento</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

